// extracted by mini-css-extract-plugin
export default {"button":"mDRfqQtq","icon":"tOkO0Xyp","enhanceButton":"GO9jFXe8","infoText":"u8dpk93P","heading":"GhLNZg7C","footer":"TQMkCDkd"};